import { Separator } from '../../atoms/Separator/Separator';
import { RichText } from '../../molecules/RichText/RichText';
import { ProductOverviewProps } from './ProductOverview.types';

export const ProductOverview = ({
  summary,
  description,
  microcopy,
  className = '',
}: ProductOverviewProps) => {
  return (
    <section className={className}>
      <p className="body mt-8 whitespace-pre-line md:mt-0">{summary}</p>

      {summary ? <Separator className="mb-8 mt-8 md:mb-9 md:mt-12" /> : null}

      <h3 className="body-bold mb-8 font-medium md:mb-8">{microcopy.title}</h3>

      <RichText
        html={description}
        className="[&_h3]:body-bold [&_h3]:mb-6 [&_h3]:font-medium md:[&_h3]:mb-8"
      />
    </section>
  );
};
